// The client slice is on createSlice/createAppAsyncThunk (SCRUM-1017); the only
// legacy action string still dispatched is GET_CLIENTS_BY_COUNTRYCODE, kept because
// productReducer ALSO handles it (cross-slice coupling — see clientSlice.js).
export const GET_CLIENTS_BY_COUNTRYCODE = "GET_CLIENTS_BY_COUNTRYCODE";
